export default __webpack_public_path__ + "static/media/github-logo.d1bb13ce.svg";